<template>
<div id="millia">
<i class="layui-icon layui-icon-left goBack" @click="goBack">返回</i>
<div class="login">
<div class="ht">用户注册</div>
<form action="post" class="layui-form">
<ul class="userInfo">
<li><input type="text" name="phone" lay-verify="required|phone" autocomplete="off" placeholder="请输入手机号" class="layui-input" v-model="phone"></li>
<li>
<div class="layui-input-inline">
<input type="text" name="code" lay-verify="required|code" placeholder="请输入验证码" autocomplete="off" class="layui-input" v-model="code">
</div>
<button type="button" class="layui-btn ml10" @click="GetCode" :disabled="!disabled">{{getCodeTxt}}</button>
</li>
<li><input type="password" name="password" lay-verify="required" autocomplete="off" placeholder="请输入密码" class="layui-input" v-model="password"></li>
<li><input type="password" name="passwordConfirm" lay-verify="required" autocomplete="off" placeholder="请再输一次密码" class="layui-input" v-model="passwordConfirm"></li>
<li><button type="button" lay-submit class="layui-btn layui-btn-lg layui-btn-normal" @click="PostRegist">提交注册</button></li>
</ul>
</form>
</div>
</div>
</template>
<script>
export default {
    name: "Regist",
    data () {
        return {
                phone:"",
                code:"",
                disabled:true,
                getCodeTxt:"获取验证码",
                password:"",
                passwordConfirm:"",
        }
    },
    methods: {
        //获取验证码
        GetCode:function(){
            if(!(/^1[3456789]\d{9}$/.test(this.phone))){
               layer.alert("请填写正确的手机号码");
            }else{
                //发送手机号到服务器
                let url = "api/sms/sendSms";
                let param = {
                    type:"register",
                    phone:this.phone
                }
                this.$ajax.get(url,param).then(function (response) {
                    if (response.data.status==1) {
                        let time = 60;
                        let timer = setInterval(() => {
                            if(time == 0) {
                                clearInterval(timer);
                                this.disabled = true;
                                this.getCodeTxt = "获取验证码";
                            } else {
                                this.getCodeTxt =time + '秒后重试';
                                this.disabled = false;
                                time--
                            }
                        },1000);
                    }else{
                        console.log(response.data.info);
                    }
                }.bind(this)).catch(function (err) {
                    console.log("连接失败");
                }.bind(this));
            }
        },
        //写入用户注册信息
        PostRegist:function(){
            if(this.password==this.passwordConfirm){
               let url = "api/login/register";
                let params = {
                    username:this.phone,
                    password:this.password,
                    sms_code:this.code
                }
                this.$ajax.post(url,params).then(function (response) {
                    console.log(response.data);
                    if (response.data.status==1) {
                        localStorage.setItem("token5",response.data.data.token);
                        localStorage.setItem("userPhoneName",response.data.data.username);
                        layer.alert("注册成功");
                        this.$router.push('/UserInfo');
                    }else{
                        layer.alert(response.data.info);
                    }
                }.bind(this)).catch(function (err) {
                    console.log("连接失败");
                }.bind(this));
            }else{
                layer.alert("两次输入的密码不相同");
            }
        },
        //返回
        goBack() {
            this.$router.push('/')
        }
    },
    mounted(){
        //layui.use('form', function(){
        //    var form = layui.form;
        //    form.verify({

        //    });
        //});
    }
}
</script>
<style scoped>
#millia{display:flex;justify-content:flex-start;align-items:center;flex-direction:column;height:100%;background:url(../assets/bg.jpg) fixed  #0f7fd1 no-repeat bottom center;background-size:100% auto;}
.goBack{position:absolute;left:1rem;top:1rem;font-size:1.6rem;color:#fff;font-weight:bold;text-shadow:0 0 1px #ccc}
</style>